export default __webpack_public_path__ + "static/Poster-Perroquet-fold-1-3ad1c18c17e4af4412472373aba97e88.jpg";